
export const variableChoices = [
    {value: 'br', label: 'Br'},
    {value: 'bt', label: 'Bt'},
    {value: 'bp', label: 'Bp'},
    {value: 'vr', label: 'Vr'},
    {value: 'vt', label: 'Vt'},
    {value: 'vp', label: 'Vp'},
    {value: 'jr', label: 'Jr'},
    {value: 'jt', label: 'Jt'},
    {value: 'jp', label: 'Jp'},
    {value: 'va', label: 'Va'},
    {value: 'rho', label: 'Rho'},
    // {value: 'p', label: 'P'},
    {value: 't', label: 'T'},
    {value: 'em', label: 'em'},
    {value: 'ep', label: 'ep'},
    // {value: 'zm', label: 'zm'},
    // {value: 'zp', label: 'zp'},
    {value: 'heat', label: 'Heating'},
];

export const timeSeriesVariableChoices = [
    {value: 'br', label: 'Br'},
    {value: 'bt', label: 'Bt'},
    {value: 'bp', label: 'Bp'},
    {value: 'vr', label: 'Vr'},
    {value: 'vt', label: 'Vt'},
    {value: 'vp', label: 'Vp'},
    {value: 'rho', label: 'Rho'},
    {value: 't', label: 'T'},
];

export const dataProductChoices = [
    {value: 'null', label: 'None'},
    {value: 'chmap', label: 'CH Map'}
]

export const mapResolutionChoices = [
    {value: 128, label: 'X-Low (128)'},
    {value: 256, label: 'Low (256)'},
    {value: 512, label: 'Medium (512)'},
    {value: 1024, label: 'High (1024)'},
]

export const solutionChoices = [
    {value: 'cor', label: 'Coronal'},
    {value: 'hel', label: 'Heliospheric'}
];

export const sliceChoices = [
    {value: 'r', label: 'Radial'},
    {value: 't', label: 'Latitudinal'},
    {value: 'p', label: 'Longitudinal'}
];

export const gridChoices = [
    {value: 'null', label: 'No Grid'},
    {value: 'major', label: 'Major Ticks'},
    {value: 'minor', label: 'Minor Ticks'}
];

export const resolutionChoices = [
    {value: 72, label: 'Low (72)'},
    {value: 100, label: 'Med-Low (100)'},
    {value: 150, label: 'Medium (150)'},
    {value: 200, label: 'Med-High (200)'},
    {value: 300, label: 'High (300)'},
    {value: 600, label: 'HD (600)'},
];

export const unitChoices = [
    {value: 'code', label: 'Code'},
    {value: 'real', label: 'Real'}
];

export const lineWidthChoices = [
    {value: 0.5, label: 1},
    {value: 0.8, label: 2},
    {value: 1, label: 3},
    {value: 1.5, label: 4},
    {value: 2.25, label: 6}
];

export const lineStyleChoices = [
    {value: 'solid', label: '⎯'},
    {value: 'dotted', label: '・・'},
    {value: 'dashed', label: '– –'},
    {value: 'dashdot', label: '・–'}
];

export const pointSymbolsChoices = [
    {value: 'none', label: 'None'},
    {value: '+', label: '+'},
    {value: '*', label: '*'},
    {value: '.', label: '∙'},
    {value: 'D', label: '◆'},
    {value: '^', label: '^'},
    {value: 's', label: '■'},
    {value: 'x', label: 'X'},
    {value: 'o', label: '●'}
];

export const scChoicesWithData = [
    {value: 'omni', label: 'OMNI'},
    {value: 'psp', label: 'Parker'},
    {value: 'solo', label: 'Solar Orbiter'},
    {value: 'stereoa', label: 'Stereo Ahead'},
    {value: 'stereob', label: 'Stereo Behind'},
    {value: 'ulysses', label: 'Ulysses'},
    {value: 'voyager1', label: 'Voyager 1'},
    {value: 'voyager2', label: 'Voyager 2'},
    {value: 'pioneer10', label: 'Pioneer 10'},
    {value: 'pioneer11', label: 'Pioneer 11'},
    {value: 'pioneerv', label: 'Pioneer Venus 12'},
    {value: 'helios1', label: 'Helios 1'},
    {value: 'helios2', label: 'Helios 2'},
];

export const scChoicesWithoutData = [
    {value: 'soho', label: 'SOHO'},
    {value: 'bepi', label: 'Bepi Colombo'},
    {value: 'maven', label: 'MAVEN'},
    {value: 'messenger', label: 'MESSENGER'},
    {value: 'mercury', label: 'Mercury'},
    {value: 'venus', label: 'Venus'},
    {value: 'earth', label: 'Earth'}
]


export const vignetteChoices = [
    {value: 'null', label: 'None'},
    {value: 'newkirk', label: 'Newkirk'},
    {value: 'polytropic', label: 'Standard Polytropic'},
    {value: 'newkirk_extended', label: 'Newkirk Extended'},
    {value: 'mhd', label: 'MHD'},
    {value: 'coronagraph', label: 'Coronagraph'}
];


export const coronagraphsSrcIdChoices = [
    {value: 83, label: "MLSO | KCOR"}
];

export const heliosphericImagersSrcIdChoices = [
    {value: 'earth', label: "Earth's View"},
    {value: 'wispr1', label: 'Parker | WISPR1'},
    {value: 'wispr2', label: 'Parker | WISPR2'},
    {value: 'lasco', label: 'SOHO | LASCO C2'},
    {value: 'metis', label: 'SOLO | METIS'},
    {value: 'cor2', label: 'Stereo Ahead | COR2'},
    {value: 'nfi', label: 'PUNCH | NFI'},
    {value: 'wfi', label: 'PUNCH | WFI'},
];


export const euvFilterChoices = [
    {group: 'SDO | AIA'},
    {value: 'aia_94', label: "94 Å"},
    {value: 'aia_131', label: "131 Å"},
    {value: 'aia_171', label: "171 Å"},
    {value: 'aia_193', label: "193 Å"},
    {value: 'aia_211', label: "211 Å"},
    {value: 'aia_335', label: "335 Å"},
    {group: 'SOHO | EIT'},
    {value: 'eit_171', label: "171 Å"},
    {value: 'eit_195', label: "195 Å"},
    {value: 'eit_284', label: "284 Å"},
    {group: 'Stereo Ahead | EUVI'},
    {value: 'euvia_171', label: "171 Å"},
    {value: 'euvia_195', label: "195 Å"},
    {value: 'euvia_284', label: "284 Å"},
    {group: 'Stereo Behind | EUVI'},
    {value: 'euvib_171', label: "171 Å"},
    {value: 'euvib_195', label: "195 Å"},
    {value: 'euvib_284', label: "284 Å"},
    {group: 'GOES | SUVI'},
    {value: 'suvi_94', label: "94 Å"},
    {value: 'suvi_131', label: "131 Å"},
    {value: 'suvi_171', label: "171 Å"},
    {value: 'suvi_195', label: "195 Å"},
    {value: 'suvi_284', label: "284 Å"},
    {group: 'Solar Orbiter | EUI/FSI'},
    {value: 'fsi_174', label: "174 Å"},
    {value: 'fsi_304', label: "304 Å"},
    {group: 'Hinode | XRT'},
    {value: 'xrt_al_mesh', label: "Al Mesh"},
    {value: 'xrt_al_poly', label: "Al Poly"},
    {value: 'xrt_be_thin', label: "Be Thin"},
    {value: 'xrt_ti_poly', label: "Ti Poly"},
]

export const euvImagersSrcIdChoices = [
    {group: 'SDO | AIA'},
    {value: 8, label: "94 Å"},
    {value: 9, label: "131 Å"},
    {value: 10, label: "171 Å"},
    {value: 11, label: "193 Å"},
    {value: 12, label: "211 Å"},
    {value: 14, label: "335 Å"},
    {group: 'Solar Orbiter | FSI'},
    {value: 84, label: "174 Å"},
]

export const corModelFilters = [
    {value: 'thermo_1', label: "Thermo 1"},
    {value: 'thermo_2', label: "Thermo 2"},
    {value: 'poly', label: "Polytropic"},
    {value: 'cme', label: "CME"},
    {value: 'psp', label: "Parker"},
    {value: 'eclipse', label: "Eclipse"},
    {value: 'carrington', label: "Carrington Runs"}
];

export const runTypeFilters = [
    {value: 'ss', label: "Steady-State"},
    {value: 'td', label: "Time Dependent"},
    {value: 'co', label: "Collection"}
];

export const timeRangeSpansFilters = [

];

export const timeOfInterestEventsFilters = [
    { value: '', label: 'None' },
    { value: '2000-07-14 10:03:00', label: 'Bastille Day Event' },
    { value: '2003-10-31 00:00:00', label: 'Halloween Solar Storms' },
    { value: '2024-05-09 12:00:00', label: 'Gannon Solar Storm' },
    { value: '2017-08-21 18:26:40', label: 'Total Eclipse 2017-08-21' },
    { value: '2019-07-02 19:24:08', label: 'Total Eclipse 2019-07-02' },
    { value: '2020-12-14 16:14:39', label: 'Total Eclipse 2020-12-14' },
    { value: '2021-12-04 07:34:38', label: 'Total Eclipse 2021-12-04' },
    { value: '2024-04-08 18:18:29', label: 'Total Eclipse 2024-04-08' },
    { value: '2018-11-06 03:27:50', label: 'Parker Encounter 01' },
    { value: '2019-04-04 22:39:55', label: 'Parker Encounter 02' },
    { value: '2019-09-01 17:50:17', label: 'Parker Encounter 03' },
    { value: '2020-01-29 09:37:41', label: 'Parker Encounter 04' },
    { value: '2020-06-07 08:23:03', label: 'Parker Encounter 05' },
    { value: '2020-09-27 09:16:01', label: 'Parker Encounter 06' },
    { value: '2021-01-17 17:39:18', label: 'Parker Encounter 07' },
    { value: '2021-04-29 08:46:51', label: 'Parker Encounter 08' },
    { value: '2021-08-09 19:10:31', label: 'Parker Encounter 09' },
    { value: '2021-11-21 08:25:23', label: 'Parker Encounter 10' },
    { value: '2022-02-25 15:35:52', label: 'Parker Encounter 11' },
    { value: '2022-06-01 22:50:05', label: 'Parker Encounter 12' },
    { value: '2022-09-06 06:03:34', label: 'Parker Encounter 13' },
    { value: '2022-12-11 13:15:48', label: 'Parker Encounter 14' },
    { value: '2023-03-17 20:30:34', label: 'Parker Encounter 15' },
    { value: '2023-06-22 03:45:54', label: 'Parker Encounter 16' },
    { value: '2023-09-27 23:28:26', label: 'Parker Encounter 17' },
    { value: '2023-12-29 00:55:05', label: 'Parker Encounter 18' },
    { value: '2024-03-30 02:21:23', label: 'Parker Encounter 19' },
    { value: '2024-06-30 03:47:14', label: 'Parker Encounter 20' },
    { value: '2024-09-30 05:14:49', label: 'Parker Encounter 21' },
    { value: '2024-12-24 11:40:57', label: 'Parker Encounter 22' },
    { value: '2025-03-22 22:24:55', label: 'Parker Encounter 23' },
];

export const sliceLabels = {
    "r": "Radius",
    "t": "Latitude",
    "p": "Longitude"
}


export const realLabels = {
    "b": "nT",
    "br": "nT",
    "bt": "nT",
    "bp": "nT",
    "jr": "statamp/\u00B2",
    "jt": "statamp/\u00B2",
    "jp": "statamp/cm\u00B2",
    "rho": "g/cm\u00B3",
    "t": "K",
    "p": "erg/\u00B2",
    "v": "km/s",
    "vr": "km/s",
    "vt": "km/s",
    "vp": "km/s",
    "va": "km/s",
};

export const variableDescriptions = {
    br: 'Magnetic Field (Radial Component)',
    bt: 'Magnetic Field (Theta Component)',
    bp: 'Magnetic Field (Phi Component)',
    jr: 'Current Density (Radial Component)',
    jt: 'Current Density (Theta Component)',
    jp: 'Current Density (Phi Component)',
    rho: 'Density',
    t: 'Temperature',
    p: 'Thermal Pressure',
    vr: 'Velocity (Radial Component)',
    vt: 'Velocity (Theta Component)',
    vp: 'Velocity (Phi Component)',
    va: 'Alfven Speed',
    em: 'Wave Energy Density (Anti-Parallel to the Field)',
    ep: 'Wave Energy Density (Parallel to the Field)',
    zm: '',
    zp: '',
    heat: 'Local Coronal Heating Rate',
    chmap: 'Coronal Hole Map',
    omas: 'Output Log'
}

export const carouselRedirectList = [
    {alt: 'slide_1', img: 'slide_1', redirect: '/mhdweb2/tools/white-light'},
    {alt: 'slide_2', img: 'slide_2', redirect: '/mhdweb2/tools/euv'},
    {alt: 'slide_3', img: 'slide_3', redirect: '/mhdweb2/tools/spacecraft-mapping'},
    {alt: 'slide_4', img: 'slide_4', redirect: '/mhdweb2/tools/spacecraft-mapping'},
    {alt: 'slide_5', img: 'slide_5', redirect: '/mhdweb2/tools/euv'},
    {alt: 'slide_6', img: 'slide_6', redirect: '/mhdweb2/tools/euv-comparison'},
    {alt: 'slide_7', img: 'slide_7', redirect: '/mhdweb2/tools/coronagraphs'},
    {alt: 'slide_8', img: 'slide_8', redirect: '/mhdweb2/tools/spacecraft-mapping'},
    {alt: 'slide_9', img: 'slide_9', redirect: '/mhdweb2/tools/time-series'},
    {alt: 'slide_10', img: 'slide_10', redirect: '/mhdweb2/tools/white-light'},
    {alt: 'slide_11', img: 'slide_11', redirect: '/mhdweb2/tools/euv-comparison'},
    {alt: 'slide_12', img: 'slide_12', redirect: '/mhdweb2/tools/spacecraft-mapping'},
    {alt: 'slide_13', img: 'slide_13', redirect: '/mhdweb2/tools/white-light'},
    {alt: 'slide_14', img: 'slide_14', redirect: '/mhdweb2/tools/coronagraphs'},
    {alt: 'slide_15', img: 'slide_15', redirect: '/mhdweb2/tools/plot2d'},
    {alt: 'slide_16', img: 'slide_16', redirect: '/mhdweb2/tools/plot2d'},
    {alt: 'slide_17', img: 'slide_17', redirect: '/mhdweb2/tools/euv'},
    {alt: 'slide_18', img: 'slide_18', redirect: '/mhdweb2/tools/data-products'},
    {alt: 'slide_19', img: 'slide_19', redirect: '/mhdweb2/tools/time-series'},
    {alt: 'slide_20', img: 'slide_20', redirect: '/mhdweb2/tools/white-light'},
    {alt: 'slide_21', img: 'slide_21', redirect: '/mhdweb2/tools/spacecraft-mapping'},
    {alt: 'slide_22', img: 'slide_22', redirect: '/mhdweb2/tools/time-series'},
    {alt: 'slide_23', img: 'slide_23', redirect: '/mhdweb2/tools/plot2d'},
    {alt: 'slide_24', img: 'slide_24', redirect: '/mhdweb2/tools/plot1d'},
    {alt: 'slide_25', img: 'slide_25', redirect: '/mhdweb2/tools/euv-comparison'},
];
